import { Filter, Star } from 'grommet-icons';
import styled, { css } from 'styled-components';

const filledIcon = css`
  path[fill='none'] {
    fill: rgb(229 36 59) !important;
  }
  polygon[fill='none'] {
    fill: rgb(229 36 59) !important;
  }
`;

interface FilledIconProps {
  $filled?: string;
}

// A favorite is a gold star (the design's favorite color, accent-6)
const filledStar = css`
  path,
  polygon {
    fill: #a1660d !important;
    stroke: #a1660d !important;
  }
`;

export const FavoriteFilled = styled(Star)<FilledIconProps>`
  ${(props) => (props.$filled ? filledStar : '')}
`;

export const FilterFilled = styled(Filter)<FilledIconProps>`
  ${(props) => (props.$filled ? filledIcon : '')}
`;
